import { MatLegacyFormFieldDefaultOptions as MatFormFieldDefaultOptions } from '@angular/material/legacy-form-field';

export const matFormFieldConfig: MatFormFieldDefaultOptions = {
  appearance: 'outline',
  floatLabel: 'always',
  hideRequiredMarker: true,
};
